import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/placeholder.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import styles from './styles.m.scss'
import './styles.scss'
import { FetchErrorMessage } from 'components/fetchErrorMessage'
import { LocaleContext } from '../../contexts/locale'
import { MunicipalitySearch } from '@ta-interaktiv/react-municipality-search'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { AtmBackendResponse } from 'types/atmBackendResponse'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { ArticleTeasers, SortMode } from '@ta-interaktiv/react-article-teasers'
import { ScrollToTopOnMount } from 'components/scrollToTop'
import LOCALES from '../main/locales.js'
import config from 'config'

interface Props {
  municipalityId: string | null
  onMunicipalitySelection: (config: { GDENR: number }) => void
}

interface State {
  articleText: string | null
  title: string
  lead: string
  errorMessage: string | null
  teaserList: Array< string >,
  chartId: string | null
}

export class Article extends React.Component<Props, State> {
  static contextType = LocaleContext
  static charts = require('../../data/charts.csv')
  static tenants = require('../../data/tenants.csv')

  state = {
    articleText: null,
    title: LOCALES.title[this.context],
    lead: LOCALES.lead[this.context],
    errorMessage: null,
    teaserList: [],
    chartId: null
  }


  currentLocale = this.context

  /**
   * Infers the matching DW chart id for a given bfs and the current locale
   * @param  bfs Commune UID
   */
  getChartId(bfs: string, locale: 'de' | 'fr') {
    const proms = new Promise((resolve, reject) => {
      if (Article.charts.filter(
        o => o.bfs === bfs && o.lang === locale
      )[0] !== undefined) {
        resolve(Article.charts.filter(
          o => o.bfs === bfs && o.lang === locale
        )[0].chart_id)
      } else {
        reject(new Error(404))
      }})
        // this.handleError(error)
    return proms
  }
  /**
   * Retrieves processed texts from initial wordsmith templates
   *
   * @param  bfs Commune UID
   * @param locale
   */
  getBackendText(bfs: string, locale: 'de' | 'fr') {
    const BASE_URL = config.apiBaseUrl
    const API_ENDPOINT = `/api/geostar/v1/articles/${config.tid}/${bfs}`
    const endpoint = new URL(API_ENDPOINT, BASE_URL)
    endpoint.searchParams.append('tenant', parseHostname().publicationName) // 20200927

    const url = endpoint

    // noinspection JSIgnoredPromiseFromCall
    // Article.sendToDataPipeline(bfs)

    return window
      .fetch(url.href, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
      .then(response => {
        if (response.ok) {
          return response.json() as Promise<AtmBackendResponse>
        } else {
          const error = {
            'message': 'municipalityId not found'
          }
          // this.handleError(error)
          throw new Error(404)
        }
      }).catch(e => {
        // this.handleError(e)
        throw new Error(500)
      })
  }
  
  /**
   * Replaces tagesanzeiger.ch and 24heures.ch with the current hostname
   * in the text that is passed as data
   * @param  data The text to replace domains in
   */
  findAndReplaceTamediaDomains(data) {
    // iterate over every tenant and replace with current tenant
    Article.tenants.map(tenant => {
      const domain = tenant.domain + '.ch'
      const regex = new RegExp(this.regExpEscape(domain), 'g')
      data = data.replace(
        regex,
        parseHostname().publicationDomain
        // 'bernerzeitung.ch'
      )
    })
    return data
  }

  /**
   * RegExp helper function
   */
  regExpEscape(literal_string: string) {
    return literal_string.replace(/[-[\]{}()*+!<=:?.\/\\^$|#\s,]/g, '\\$&');
  }
  
  /**
   * Helper function to handle errors
   */
  handleError(error: Error) {
    this.setState({ errorMessage: error.message })
    console.group('Fetch Article')
    console.warn('Article could not be loaded')
    console.warn(error)
    console.groupEnd()
  }

  /**
   * Helper function for updating state upon component mount and update
   */
  updateContent() {
    const backendRawText = this.getBackendText(
      this.props.municipalityId,
      this.context
    )
    const chartId = this.getChartId(this.props.municipalityId, this.context)
    Promise.all([backendRawText, chartId])
      .then(data => {
        // Split the text according to its custom tags
        // Find the title
        const textTitle = this.extractTitle(data[0]['title'])
        const textLead = this.extractLead(data[0]['lead'])
        this.setState({
          articleText: this.findAndReplaceTamediaDomains(data[0]['content']),
          title: textTitle,
          lead: textLead,
          errorMessage: null,
          chartId: data[1]
        })
      })
      .catch(e => {
        this.handleError(e)
      })
  }

  /**
   * Find the title from the received text
   * @param text
   */
  extractTitle(text: string) {
    if (text) {
      return text
    } else {
      return LOCALES.title[this.context]
    }
  }

  extractLead(text: string) {
    if (text) {
      return text
    } else {
      return LOCALES.lead[this.context]
    }
  }

  createDangerousHtmlObject(text: string) {
    return {__html: this.state.articleText}
  }

  componentDidMount() {
    this.updateContent()

    // update teaser list based on hostname
    const actualDomain = parseHostname().publicationName
    let teaserList = []
    switch (this.context) {
      case 'de':
        teaserList.push('903862179538')
        teaserList.push('595810769317')
        break;
      case 'fr':
        teaserList.push('531559250374')
        teaserList.push('802522774712')
        break;
      default:
        break;
    }
    this.setState({
      teaserList: teaserList
    })
  }

  componentDidUpdate(prevProps: Props): void {
    if (
      prevProps.municipalityId !== this.props.municipalityId ||
      this.currentLocale !== this.context
    ) {
      // make sure that we save the new locale
      this.currentLocale = this.context

      this.updateContent()
    }
  }

  render() {
    const containerClasses = 'step article'
    const chartUrl = 'https://datawrapper.dwcdn.net/' + this.state.chartId + '/'
    let textSliceIndex = 0

    const Search = (
      <aside className='ui secondary grey segment'>
        <h4 className='ui tiny header'>
          {LOCALES.municipalitySearchBoxTitle[this.context]}
        </h4>
        <MunicipalitySearch
          locale={this.context}
          dedupe={true}
          showLastSelectedMunicipalities={true}
          numberOfLastSelectedMunicipalities={1}
          onSelectionHandler={this.props.onMunicipalitySelection}
        />
      </aside>
    )

    // Setup content for the default case
    let Content = (
      <div className='ui text container'>
        { this.state.chartId && (
          <AutofitIFrame
          title=''
          aria-label='Grafik'
          height={ window.innerWidth > 600 ? '520px' : '470px' }
          src={ chartUrl }
        />)}
        <div className={styles.railContainer}>
            {this.state.articleText && (
              <div id='federal-votes' dangerouslySetInnerHTML={this.createDangerousHtmlObject()}>
              </div>
            )}
        </div>
        <ArticleTeasers
              sorting={SortMode.REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE}
              numberOfCards='two'
              forceDomain={parseHostname().publicationName}
              articleIds={this.state.teaserList}
            />
      </div>
    )

    // show something else in case of an error
    if (this.state.errorMessage) {
      Content = (
        <div className='ui text container'>
          <FetchErrorMessage
            status={this.state.errorMessage ?? ''}
            locale={this.context}
          />
        </div>
      )
    }

    return (
      <>
        <header className='ui vertical  very fitted  segment'>
          <div className='ui container'>
            <div className='ui header'>
              <h1>{this.state.title}</h1>
              <h2>{this.state.lead}</h2>
            </div>
          </div>
        </header>
        <ScrollToTopOnMount />
        <div
          className='ui vertical padded segment'
          // id='main-content'
          style={{ paddingBottom: 0 }}
        >
          <div className={containerClasses} style={{ zIndex: 10 }}>
            {Content}
            <div
              className='ui vertical colored padded segment'
              style={{ marginTop: '3rem' }}
            >
              <div className='ui text container'>{Search}</div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
